import $$ from 'cmn-utils'

const baseUrl = "/api/linkage/";
export default {
    create: (params) => {
        const {executeList} = params
        delete params.executeList
        executeList.filter(item => item != undefined).map((item, index) => {
            params['executeList[' + index + "].actionCode"] = item.actionCode;
            params['executeList[' + index + "].deviceId"] = item.deviceId;
            params['executeList[' + index + "].params"] = JSON.stringify(item.params);
        })
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    get: (params) => {
        return $$.get(baseUrl + 'get', params)
    },
    changeState: (params) => {
        return $$.post(baseUrl + 'update-state', params)
    },
    update: (params) => {
        const {executeList} = params
        delete params.executeList
        executeList.filter(item => item != undefined).map((item, index) => {
            params['executeList[' + index + "].actionCode"] = item.actionCode;
            params['executeList[' + index + "].deviceId"] = item.deviceId;
            params['executeList[' + index + "].params"] = JSON.stringify(item.params);
        })
        return $$.post(baseUrl + 'update', params)
    },
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    deviceLinkageList: (params) => {
        return $$.get(baseUrl + 'device-linkage-list', params)
    },

}